import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RetrySignInButton, SignInButton, } from '@zurich-framework/nextapp/components';
import { useNextAppSession } from '@zurich-framework/nextapp/hooks';
import { useQueryString, useTranslation } from '@zurich/common/hooks';
import { Container, NoSSR, Typography } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import { InfoCard } from '../InfoCard';
const AdditionalInfoContainerStyled = styled('p')(() => ({}));
const ErrorContainerStyled = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(8),
    fontSize: '0.7em',
}));
const ButtonContainerStyled = styled('div')(() => ({
    textAlign: 'right',
}));
export function AuthError() {
    const { t } = useTranslation();
    const { session } = useNextAppSession({ required: false });
    const component = useQueryString({ key: 'component' });
    const error = useQueryString({ key: 'error' });
    const additionalInfo = t(`portal:errors.custom.auth.descriptions.${component}.errors.${error}`, '');
    return (_jsx(Container, { spacing: 5, children: _jsx(InfoCard, { title: _jsx(Typography, { variant: "h4", children: t('portal:errors.custom.auth.title') }), description: _jsxs("div", { children: [_jsx("p", { children: t(`portal:errors.custom.auth.descriptions.${component}.default`, t('portal:errors.custom.auth.descriptions.error.default', '')) }), additionalInfo && (_jsx(AdditionalInfoContainerStyled, { children: additionalInfo })), _jsx(ButtonContainerStyled, { children: session ? _jsx(RetrySignInButton, {}) : _jsx(SignInButton, {}) }), _jsx(ErrorContainerStyled, { children: _jsxs(NoSSR, { children: [_jsxs("span", { children: ["Error: ", component, "/", error] }), session && (_jsxs("div", { children: [_jsxs("span", { children: ["User: ", session.user?.name ?? 'n/a'] }), _jsxs("span", { children: ["Groups: ", session.groups.join(',') || 'n/a'] })] }))] }) })] }) }) }));
}
